export default __webpack_public_path__ + "static/media/E24.ed6a40ea.jpeg";